module.exports = __webpack_public_path__ + "static/media/icon_emh_active.b5d01f2c.svg";